import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { FormGroup,FormControl,Validators } from '@angular/forms';
import { getLocalJSON } from '../../_helpers/storage.util';
declare var $:any;

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss']
})

export class SigninComponent {
  
  public loading:boolean = false;
  public submitted:boolean = false;
  selectedFile:any;
  public rememberCheck : boolean = false ;
  public email : any ;
  public password : any;
  public popMessage:any='';

  loginData = new FormGroup({
    email:new FormControl('',Validators.compose([
      Validators.required, Validators.email  ])),
    password:new FormControl('',Validators.compose([
      Validators.required,Validators.minLength(8),
      Validators.maxLength(30) ,
      Validators.pattern('^(?=.*[A-Z])(?=.*\\d)[A-Za-z\\d-_}/\{|:;?!@#$%^&*+=~<>()`]{8,30}') 
    ])),
  })
  
   get f() { return this.loginData.controls; }

  constructor(public router: Router, private service: GlobalService) { 
    if(localStorage.getItem('grw_Remember')){
      var data = getLocalJSON('grw_Remember');
      this.email = data.email;
      this.password = data.password;
      this.rememberCheck = data.check;
    }
  }

  ngOnInit(): void {
  }


  Onsubmit(){
    this.submitted = true;    
      let userdetail = this.loginData;
      if(userdetail.valid){
        this.loading=true;
        var url="/login";
        var detail={"email": (userdetail.value.email)?.toLowerCase(),"password": userdetail.value.password};
        this.service.PostApis(detail,url).subscribe(((response:any)=>{
          if(response.success ==1){
            if(this.rememberCheck){
              var detail = {'email':(userdetail.value.email)?.toLowerCase(),'password':userdetail.value.password,'check':this.rememberCheck}
              localStorage.setItem('grw_Remember',<any> JSON.stringify(detail));
            } else {
              localStorage.removeItem('grw_Remember');
            } 
            localStorage.setItem('grw_login',<any> JSON.stringify(response.data || {}));
            localStorage.setItem('grw_logincurrency', response.data.userCurrency);
            localStorage.setItem('grw_currencySymbol',response.data.userCurrencySymbol);
            if(response.data.userCurrency !=''){
              this.service.getConversionRate(response.data.userCurrency,2);
            }
            this.service.setSubject(response.data);
            localStorage.setItem('grw_token',response.data.token);
            if(response.data.firstTimeLogin == false){
              localStorage.setItem('grw_first','1');  
              this.router.navigate(['/dashboard']);            
            } else {
              if(response.data.profile_complete ==false ){
                this.router.navigate(['/edit-profile']);
              } else {
                this.router.navigate(['/dashboard']);
              } 
            }
            this.loginData.reset();
            this.submitted = false;  
            this.loading=false;  
          } else {
            if(response.message=='Email verification is pending'){
              $('#pops').trigger('click');
              this.popMessage=response.message;
            }
            this.service.dangerAlert(response.message);
            this.loading=false;
          }
        }), (error:any) => {
          this.loading=false;
        });
      } else{
        window.scroll(0,0);
      }
  }

  getCheckType(event:any){
    this.rememberCheck = event.target.checked;
  }

  showHide(str: any) {
    var input = $($(str).attr("toggle"));
    if (input.attr("type") == "password") {
      input.attr("type", "text");
      $(str).removeClass("fa-regular fa-eye-slash");
      $(str).addClass("fa-regular fa-eye ");
    } else {
      input.attr("type", "password");
      $(str).removeClass("fa-regular fa-eye ");
      $(str).addClass("fa-regular fa-eye-slash");
    }
  }
}
